import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";

const nav = [
  { to: "/", label: "Beranda", id: "nav-home" },
  { to: "/pesan", label: "Pesan Foto", id: "nav-order" },
  { to: "/cek-pesanan", label: "Cek Pesanan", id: "nav-track" },
];

export default function SiteHeader() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2 shrink-0">
          <img src="/assets/logo.png" alt="Lensa Juara" className="h-10 w-auto bg-white rounded-sm px-1" />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2 text-sm overflow-x-auto">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end
              data-testid={n.id}
              className={({ isActive }) =>
                `px-2 sm:px-3 py-2 font-display uppercase tracking-wide text-base whitespace-nowrap transition-colors duration-150 ${isActive ? "text-[#FF5A00]" : "text-neutral-300 hover:text-white"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Show when="signed-in">
            <NavLink to="/admin" data-testid="nav-admin" className="px-2 sm:px-3 py-2 font-display uppercase text-base text-neutral-300 hover:text-white">Dashboard</NavLink>
            <UserButton />
          </Show>
        </nav>
      </div>
    </header>
  );
}
